import { useGeneralAppStore } from "../store/generalAppStore";
import { useAxiosError } from "./axios/useAxiosError";
import { useAbortController } from "./useAbortController";
import { useActasStore } from "../store/actasStore";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useActaDetalleStore } from "../store/actaDetalleStore";
import { axios } from "../utils/axios";
import { getActaDetalleHandler } from "../handlers/actaDetalle.handler";

export const useActas = () => {
    const signal = useAbortController();

    //~ HOOKS
    const { handleAxiosError } = useAxiosError();

    //? ESTADOS GLOABALES
    const { handlerLoading, handlerModal, modals } = useGeneralAppStore();
    const { actas, actasFilter, setActas, setActasFilter, firstSetActas } = useActasStore();
    const {
        setColeccionActasDetalle,
        coleccionActasDetalle,
        setActa,
        actaDetalle,
        setAllActaDetalle,
        setRecibo,
        acta
    } = useActaDetalleStore();

    //TODO MUESTRA TODA LAS ACTAS
    const getActas = async (url = "/actas") => {
        handlerLoading({ loading: true, loadName: "actas" });
        try {
            const response = await axios().get(url, { signal });
            const { data, error } = response.data;
            if (data) firstSetActas(data.sort((a, b) => parseInt(b.numero_acta) - parseInt(a.numero_acta)));
            if (error) toast.error(error, toastOptions);
        } catch (error) {
            handleAxiosError(error);
        } finally {
            handlerLoading({ loading: false, loadName: "actas" });
        }
    };

    //TODO TRAE EL DETALLE DE UN ACTA
    const getActaDetalle = async (id, search = false) => {
        handlerLoading({ loading: true, loadName: "acta_detalle" });
        try {
            const response = await axios().get(`acta/${id}`);
            const { data, error } = response.data;
            if (data) {
                setAllActaDetalle(data);
                !search && handlerModal({ modal: true, modalName: "acta_detalle" });
            }
            if (error) toast.error(error, toastOptions);
        } catch (error) {
            handleAxiosError(error);
        }
        finally {
            handlerLoading({ loading: false, loadName: "acta_detalle" });
        }
    };

    //TODO IMPRIME ACTAS MARCADAS
    const imprimirActas = async (dataSend, setActasAImprimir = null, setRefetch = null) => {
        handlerLoading({ loading: true, loadName: "marcar_impresa" });
        try {
            const response = await axios().post("actas_a_imprimir", dataSend);
            const { data, error } = response.data;
            if (data) {
                setActasAImprimir && setActasAImprimir([]);
                setRefetch && setRefetch(true)
                // if (modals?.includes('modal_imprimir_actas2')) {
                //     getActaDetalle(acta?.id)
                // }
                setAllActaDetalle(data)
                toast.success("Se imprimieron actas correctamente", toastOptions);
                handlerModal({ modal: false, modalName: "modal_imprimir_actas" });
                handlerModal({ modal: false, modalName: "modal_imprimir_actas2" });
            }
            if (error) toast.error(error, toastOptions);
        } catch (error) {
            useAxiosError(error);
        }
        finally {
            handlerLoading({ loading: false, loadName: "marcar_impresa" });
        }
    };

    //TODO ASIGNAR ACTAS A UN NOTIFICADOR
    const asignarActasANotificador = async (dataSend, setActasAsignar = null, setActasSinEntregar = null, setRefetch = null) => {
        handlerLoading({ loading: true, loadName: "asignar_notificador" });
        try {
            const response = await axios().post('asignar_notificador', dataSend);
            const { data, error } = response.data;
            if (data) {
                // if (actas) {
                //     setActas(actas.filter(acta => acta && !dataSend.actas.includes(acta.id)))
                //     setActasFilter(actasFilter.filter(acta => acta && !dataSend.actas.includes(acta.id)))
                // }
                // actaDetalle && setAllActaDetalle({ acta: data.actas[0].acta, archivos: actaDetalle?.archivos });
                setAllActaDetalle(data)
                setActasAsignar && setActasAsignar([]);
                setActasSinEntregar && setActasSinEntregar([]);
                setRefetch && setRefetch(true)
                // if (modals?.includes('modal_asignar_actas2')) {
                //     toast.success("Se asignaron actas SEND", toastOptions);
                //     getActaDetalle(acta?.id)
                // } else {
                //     toast.success("Se asignaron actas al notificador", toastOptions);
                // }
                modals.includes('modal_asignar_actas_send') && handlerModal({ modal: false, modalName: "modal_asignar_actas_send" });
                modals.includes('modal_asignar_actas_maria') && handlerModal({ modal: false, modalName: "modal_asignar_actas_maria" });
                modals.includes('modal_asignar_actas') && handlerModal({ modal: false, modalName: "modal_asignar_actas" });
                modals.includes('modal_asignar_actas2') && handlerModal({ modal: false, modalName: "modal_asignar_actas2" });
                modals.includes("notificadores") && handlerModal({ modal: false, modalName: "notificadores" });
            }
            if (error) toast.error(error, toastOptions);
        } catch (error) {
            useAxiosError(error);
        }
        finally {
            handlerLoading({ loading: false, loadName: "asignar_notificador" });
        }
    };


    //TODO MARCAR SIN ENTREGAR MOTIVO PEDIDO NO ENTREGAR
    const marcarActasSinEntregar = async (dataSend, acta, setRefetch = null) => {
        handlerLoading({ loading: true, loadName: "actas_sin_entregar" });
        try {
            const response = await axios().post('actas_no_notificadas', dataSend);
            const { data, error } = response.data;
            if (data) {
                // actaDetalle && setAllActaDetalle({ acta: data.actas[0].acta, archivos: actaDetalle?.archivos });
                // setActasAsignar && setActasAsignar([]);
                setRefetch && setRefetch(true)
                toast.success("Se cancelo el envio de las actas en reparto", toastOptions);
                modals.includes("actas_sin_entregar") && handlerModal({ modal: false, modalName: "actas_sin_entregar" });
                await getActaDetalleHandler(acta)
            }
            if (error) toast.error(error, toastOptions);
        } catch (error) {
            useAxiosError(error);
        }
        finally {
            handlerLoading({ loading: false, loadName: "actas_sin_entregar" });
        }
    };

    //TODO QUITAR NOTIFICADOR ASIGNADO A UN ACTA
    const quitarNotificadorAsignado = async (dataSend) => {
        handlerLoading({ loading: true, loadName: "desasignar_notificador" });
        try {
            const response = await axios().post("quitar_notificador_asignado", dataSend);
            const { data, error } = response.data;
            if (data) {
                setColeccionActasDetalle(
                    coleccionActasDetalle.map((acta) => {
                        if (acta.acta.id == data.id) {
                            acta.acta = data;
                        }
                        return acta;
                    })
                );
                if (actas) {
                    setActa(data);
                    // const newActas = ;
                    setActas(actas.filter((acta) => acta.id != data.id));
                    const newActasFilter = actasFilter.filter((acta) => acta.id != data.id);
                    setActasFilter(newActasFilter);
                }
                if (actaDetalle) {
                    setAllActaDetalle({ acta: data, archivos: actaDetalle?.archivos });
                }
                handlerModal({ modal: false, modalName: "desasignar_notificador" });
                toast.success("Se desasigno el notificador del acta", toastOptions);
            }
            if (error) {
                toast.error(error, toastOptions);
            }
        } catch (error) {
            handleAxiosError(error);
        }
        finally {
            handlerLoading({ loading: false, loadName: "desasignar_notificador" });
        }
    };

    //TODO OBTENER RECIBO
    const obtenerRecibo = async (dataSend) => {
        handlerLoading({ loading: true, loadName: "obtener_recibo" });
        try {
            const response = await axios().post('obtener_ultimo_recibo', dataSend);
            const { data, error } = response.data;
            if (data) {
                setRecibo(data);
            }
            if (error) toast.error(error, toastOptions);

        } catch (error) {
            handleAxiosError(error);
        }
        finally {
            handlerLoading({ loading: false, loadName: "obtener_recibo" });
        }

    }


    return {
        getActas,
        quitarNotificadorAsignado,
        getActaDetalle,
        imprimirActas,
        asignarActasANotificador,
        marcarActasSinEntregar,
        obtenerRecibo,
    };
};
